
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppSettings } from '../app.settings';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url} from '../model/users.model';
import { User, Password, Account, UserFile } from '../model/users.model';

@Injectable()


export class UsersService {
    @LocalStorage() url: Url;

    constructor(private http:HttpClient, public appSettings:AppSettings) { 
    }

    options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

	getMembers(){
        let user = JSON.parse(localStorage.getItem('ngx_user'));

        if(user.role_id == 9){
            return this.http.get(this.url.rest + '/tms/getMembers?user_role=' + user.role_id, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
        }
        else{
            return this.http.get(this.url.rest + '/tms/getMembers', this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
        }
		
    }
    
    createMember(member: User): Observable<User> {	
        return this.http.post<User>(this.url.rest  + '/tms/createMember', member , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    createAdminAccount(member: User): Observable<User> {	
        return this.http.post<User>(this.url.rest  + '/tms/createAdminAccount', member , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    createSuperAdminAccount(member: User): Observable<User> {	
        return this.http.post<User>(this.url.rest  + '/tms/createSuperAdminAccount', member , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    createComplianceAdminAccount(member: User): Observable<User> {	
        return this.http.post<User>(this.url.rest  + '/tms/createComplianceAdminAccount', member , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    updateMember(member:Account): Observable<Account> {
        return this.http.put<Account>(this.url.rest  + '/tms/updateMember', member , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    updateAccount(account:Account): Observable<Account> {
        return this.http.put<Account>(this.url.rest  + '/tms/updateAccount', account , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    deleteMember(id: number) {
        return this.http.delete(this.url.rest  + '/tms/deleteMember/' + id, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }
    
    archiveMember(payload){
        return this.http.post(this.url.rest + '/tms/archiveMember', payload, this.options)
    }

    unarchiveMember(payload){
        return this.http.post(this.url.rest + '/tms/unarchiveMember', payload, this.options)
    }

    updatePassword(password: Password): Observable<Password> {
        return this.http.put<Password>(this.url.rest  + '/tms/updatePassword', password , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }	

    updateCustomerAcctPassword(password: Password): Observable<Password> {
        return this.http.put<Password>(this.url.rest  + '/tms/updateCustomerAcctPassword', password , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }	

    updatePasswordOfOthers(password: Password): Observable<Password> {
        return this.http.put<Password>(this.url.rest  + '/tms/updatePasswordOfOthers', password , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }	

    updateMemberStatus(id: number, value: number): Observable<any> {
        let user = JSON.parse(localStorage.getItem('ngx_user'));
        let payload = {
            user_id: user.id
        };

        return this.http.put<any>(this.url.rest  + '/tms/updateMemberStatus/' + id + '/' + value, payload, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    private extractData(res: Response) {
    	let body = res.json();
    	console.log(body);
	    if(body)
            return body || {};
        else
            return null;
    }
    private handleError(error: Response | any) {
        console.error(error.message || error);
        return Observable.throw(error.message || error);
    }	

    createFile(image_file : any): Observable<File>
    {	
        return this.http.post<File>(this.url.rest  + '/tms/upload/file', image_file , this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    deleteFile(fileName : string)
    {
    	return this.http.delete(this.url.rest  + '/tms/delete/file' + fileName)
                        
    }

    getMembersbyId(id: number) { 
        return this.http.get(this.url.rest  + '/tms/getMemberById/' + id, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    uploadImageFile(folder: string,file: string) : Observable<string>{	
        return this.http.post<string>(this.url.rest  + '/tms/upload/image/' + folder, file, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }


    saveTheme(themeData:any) : Observable<any>{	
        return this.http.post<any>(this.url.rest  + '/tms/saveTheme', themeData, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    getActiveMembers(){ 
		return this.http.get(this.url.rest  + '/tms/getActiveMembers', this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    checkUniqueLogin(login_id){
        return this.http.get(this.url.rest  + '/tms/getUserByUsername/' + login_id, this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    getSuperAdminAccounts(){ 
		return this.http.get(this.url.rest  + '/tms/getSuperAdminAccounts', this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }

    getComplianceAdminAccounts(){ 
		return this.http.get(this.url.rest  + '/tms/getComplianceAdminAccounts', this.options)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            )
    }


    getUserFiles(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest  + '/tms/getUserFiles', this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getUnverifiedUserFilesByUserId(id: number): Observable<UserFile[]> { 
        return this.http.get<UserFile[]>(this.url.rest  + '/tms/getUnverifiedUserFilesByUserId/' + id, this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getVerifiedUserFilesByUserId(id: number): Observable<UserFile[]> { 
        return this.http.get<UserFile[]>(this.url.rest  + '/tms/getVerifiedUserFilesByUserId/' + id, this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getUserFilesByUserId(id: number): Observable<UserFile[]> { 
        return this.http.get<UserFile[]>(this.url.rest  + '/tms/getUserFilesByUserId/' + id, this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }
        
    verifyUserFile(userfile: UserFile): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/verifyUserFile' , userfile , this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    updateUserFileView(userfile: UserFile): Observable<UserFile> {
        return this.http.post<UserFile>(this.url.rest  + '/tms/updateUserFileView', userfile , this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateUserFile(userfile: UserFile): Observable<UserFile> {
        return this.http.post<UserFile>(this.url.rest  + '/tms/updateUserFile', userfile , this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteUserFile(id: number, created_id: number, user_id: number): Observable<any> {
        return this.http.delete<any>(this.url.rest  + '/tms/deleteUserFile/' + id + '/' + created_id + '/' + user_id, this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createUserFile(userfile: UserFile): Observable<UserFile> {    
        return this.http.post<UserFile>(this.url.rest  + '/tms/createUserFile', userfile , this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    getVersion(): Observable<any> { 
        return this.http.get<any>(this.url.rest  + '/tms/getTMSVersion', this.options)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    // Error handling
    errorHandl(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }


}